import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { Quill } from '../../widgets/components/Input/Quill'

const ClassificationComparisionModal = ({ isActive, setIsActive }: any) => {

    const { formatMessage } = useIntl()
    const [editorContent1, setEditorContent1] = useState('')
    const [editorContent2, setEditorContent2] = useState('')
    const [editorContent3, setEditorContent3] = useState('')

    const handleCopyToManual = () => {
        setEditorContent1(editorContent2)
    }

    return (
        <Modal show={isActive} onHide={() => setIsActive()} size="lg" fullscreen>
            <Modal.Header closeButton>
                <h2>{formatMessage({ id: 'Classification Comparison' })}</h2>
            </Modal.Header>
            <Modal.Body className='container'>
                <div className='row'>
                    <div className='col-md-4 mb-md-0 mb-4'>
                        <h1 className='font-size-16 text-dark'>{formatMessage({ id: 'Manual Classification' })}</h1>
                        <div className='bg-white rounded'>
                            <Quill
                                height={'500'}
                                quillText={editorContent1}
                                setQuillText={setEditorContent1}
                            />
                        </div>
                    </div>
                    <div className='col-md-4 mb-md-0 mb-4'>
                        <div className='d-flex gap-2'>
                            <h1 className='font-size-16 text-dark'>{formatMessage({ id: 'AI Classification' })}</h1>
                            <h1 className='font-size-16 text-primary cursor-pointer' onClick={handleCopyToManual}>
                                {formatMessage({ id: '(Copy to manual)' })}
                            </h1>
                        </div>
                        <Quill
                            height={'500'}
                            quillText={editorContent2}
                            setQuillText={setEditorContent2}
                        />
                    </div>
                    <div className='col-md-4 mb-md-0 mb-4'>
                        <h1 className='font-size-16 text-dark'>{formatMessage({ id: 'Previous AI Classification' })}</h1>
                        <Quill
                            height={'500'}
                            quillText={editorContent3}
                            setQuillText={setEditorContent3}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='container px-0'>
                <div className='d-md-flex w-100 w-md-auto justify-content-end px-0 gap-3'>
                    <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
                        <button
                            type='submit'
                            className='btn bg-primary text-white custom-button-property w-100'
                        >
                            <span className='indicator-label'>{formatMessage({ id: 'Update' })}</span>
                        </button>
                    </div>
                    <div className='w-100 w-md-auto order-2 order-md-1'>
                        <button
                            type='button'
                            className='btn bg-light text-muted custom-button-property w-100'
                            onClick={() => setIsActive(false)}
                        >
                            {formatMessage({ id: 'Cancel' })}
                        </button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ClassificationComparisionModal
